// crumbCache.ts

const CACHE_KEY = 'crumbQueryCache'

interface CrumbData {
  search: string
  state: any
}

function getCache(): Record<string, CrumbData> {
  try {
    return JSON.parse(sessionStorage.getItem(CACHE_KEY) ?? '{}')
  } catch {
    return {}
  }
}

function setCrumb(pathname: string, search: string, state: any) {
  const cache = getCache()
  cache[pathname] = { search, state }
  sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache))
}

function getCrumb(pathname: string): CrumbData | undefined {
  const cache = getCache()
  return cache[pathname]
}

function clearCrumb(pathname: string) {
  const cache = getCache()
  delete cache[pathname]
  sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache))
}

function clearAllCrumbs() {
  sessionStorage.removeItem(CACHE_KEY)
}

export const crumbCache = {
  setCrumb,
  getCrumb,
  clearCrumb,
  clearAllCrumbs,
}
